<script lang="ts">
  const { text } = $props<{ text: string }>()
  const sources: Record<string, string> = {
    "https://support.apple.com/de-de/guide/iphone/iph7405291c4/ios":
      "Apple: Rufweiterleitung auf dem iPhone",
    "https://www.samsung.com/de/support/mobile-devices/wie-kann-ich-bei-meinem-galaxy-smartphone-die-rufumleitung-einstellen-oder-deaktivieren/":
      "Samsung: Rufumleitung einrichten und ausschalten",
    "https://fritz.com/apps/knowledge-base/FRITZ-Box-7590/51_Rufumleitung-in-FRITZ-Box-einrichten/":
      "FRITZ!: Rufumleitung einrichten",
  }
  const parts = $derived(text.split(/(https:\/\/[^\s]+)/g))
</script>

{#each parts as part, index (index)}
  {#if Object.hasOwn(sources, part)}
    <a href={part} target="_blank" rel="noopener noreferrer" title="Öffnet einen neuen Tab"
      >{sources[part]}</a
    >
  {:else}{part}{/if}
{/each}

<style>
  a {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 0.2em;
    overflow-wrap: anywhere;
  }
  a:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 3px;
  }
</style>
